






































import { Component, Vue } from 'vue-property-decorator';
import Video from '@/components/common/Video.vue';
import Pagination from '@/components/common/Pagination.vue';
import { getNewsList } from '@/api/index';

@Component({
  components: {
    Pagination,
    Video
  }
})
export default class NewsList extends Vue {
  public currentPage: number = 1; //分页 当前第1页
  public pageSize: number = 10; //分页 当前一页10条
  public data: object = {
    //分页组件参数
    total: 0,
    list: [],
    size: this.pageSize
  };
  get pageData() {
    //分页组件需要参数
    return {
      total: (this.data as any).total,
      currentPage: this.currentPage,
      size: this.pageSize
    };
  }

  created() {
    this.getNewsList();
  }
  public getNewsList() {
    // 获取新闻动态列表
    getNewsList({ isTop: false, pageNum: this.currentPage, size: this.pageSize }).then((res: any) => {
      if (res.code === 200) {
        this.data = res.data;
        this.$nextTick(() => {
          this.$emit('scrollToTop');
        });
      }
    });
  }

  public time(time: string) {
    // 发布时间转换为 年月日
    if (time) {
      return time.substr(0, 11);
    }
    return '';
  }
  public handleSizeChange(e: any) {
    // 切换一页显示条数
    this.currentPage = 1;
    this.pageSize = e;
    this.getNewsList();
  }
  public handleCurrentPageChange(e: any) {
    // 切换页数
    this.currentPage = e;
    this.getNewsList();
  }
  public jumpToDetail(id: number) {
    // 跳转详情
    this.$emit('scrollToTop');
    this.$emit('jumpTodetail', id);
  }
}
